export interface PasswordRules {
  length: boolean;
  uppercase: boolean;
  lowercase: boolean;
  number: boolean;
  special: boolean;
}

export function checkPasswordRules(password: string): PasswordRules {
  return {
    length: password.length >= 12,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[^A-Za-z0-9]/.test(password),
  };
}

export function validatePassword(password: string): string | null {
  const rules = checkPasswordRules(password);
  if (!rules.length) return "Password must be at least 12 characters";
  if (!rules.uppercase) return "Password must include an uppercase letter";
  if (!rules.lowercase) return "Password must include a lowercase letter";
  if (!rules.number) return "Password must include a number";
  if (!rules.special) return "Password must include a special character";
  return null;
}
